<template>
    <div>
        <div>
            <v-toolbar :extension-height="70" rounded="7">
                <h2 class="ml-3" style="color: black">Roles</h2>
            </v-toolbar>
        </div>
        <div>
            <RolesTable />
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

const RolesTable = defineAsyncComponent(() =>
    import("../../components/Auth/RolesTable.vue")
);
export default {
    name: "Roles",
    components: { RolesTable },
};
</script>

<style scoped></style>
